var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneInputIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_32804",
    "data-name": "Path 32804",
    d: "M9.366,10.682a10.556,10.556,0,0,0,3.952,3.952L14.2,13.4a1,1,0,0,1,1.294-.3,11.422,11.422,0,0,0,4.583,1.364,1,1,0,0,1,.921,1v4.462a1,1,0,0,1-.9,1A15.509,15.509,0,0,1,3.082,3.9a1,1,0,0,1,1-.9H8.539a1,1,0,0,1,1,.921A11.422,11.422,0,0,0,10.9,8.5,1,1,0,0,1,10.6,9.8l-1.238.884Zm-2.522-.657,1.9-1.357A13.41,13.41,0,0,1,7.647,5H5.01C5,5.166,5,5.333,5,5.5A13.5,13.5,0,0,0,18.5,19c.167,0,.334,0,.5-.01V16.353a13.41,13.41,0,0,1-3.668-1.1l-1.357,1.9a12.442,12.442,0,0,1-1.588-.75l-.058-.033a12.556,12.556,0,0,1-4.7-4.7l-.033-.058a12.442,12.442,0,0,1-.75-1.588Z",
    transform: "translate(-3 -3)",
    fill: "#c38f51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneInputIcon);
export default __webpack_public_path__ + "static/media/phone_input_icon.79eb6ddd5746c4324068fcc87d5b93a5.svg";
export { ForwardRef as ReactComponent };